import axiosInstance from "../services/axiosInstance";

const getStoredJson = (key) => {
    try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch (error) {
        return null;
    }
};

const getReceiptBusinessContext = () => {
    const user = getStoredJson("user") || {};
    const customerId = user.customer_id || localStorage.getItem("customer_id");
    const customer = customerId ? getStoredJson(`customer_${customerId}`) : null;

    return {
        business_name: customer?.name || user.customer_name || "Point of Sale",
        branch_name: user.branch_name || user.branch?.name || user.branch?.location || "Branch",
        cashier_name: user.username || user.email || "Cashier",
    };
};

const normalizeReceiptItems = (order) => {
    const items = order.cart || order.products || order.items || [];
    return items.map((item) => {
        const qty = Number(item.qty || item.quantity || 0);
        const price = Number(item.price || item.unit_price || 0);
        return {
            product_id: item.product_id || item.productId || item.id || null,
            name: item.name || item.product_name || `Product #${item.product_id || item.productId || item.id || ""}`,
            qty,
            price,
            line_total: Number.isFinite(Number(item.line_total)) ? Number(item.line_total) : qty * price,
        };
    });
};

export const buildReceiptPayload = (order = {}) => {
    const context = getReceiptBusinessContext();
    const items = normalizeReceiptItems(order);
    const subtotal = Number(order.subtotal ?? items.reduce((sum, item) => sum + Number(item.line_total || 0), 0));
    const discount = Number(order.discount || 0);
    const total = Number(order.total ?? subtotal - discount);
    const amountReceived = order.amount_received ?? order.cashReceived ?? null;
    const changeAmount = order.change_amount ?? (
        amountReceived === null || amountReceived === undefined
            ? null
            : Math.max(Number(amountReceived || 0) - total, 0)
    );

    return {
        ...context,
        business_name: order.business_name || order.customer_name || context.business_name,
        branch_name: order.branch_name || order.branch?.name || context.branch_name,
        cashier_name: order.cashier_name || order.cashier || order.user_name || context.cashier_name,
        order_number: order.order_number || `ORD-${order.id || Date.now()}`,
        branch_id: order.branch_id || order.branch?.id || null,
        created_at: order.created_at || order.createdAt || new Date().toISOString(),
        seat_number: order.seat_number || null,
        payment_method: order.payment_method || order.paymentMethod || "-",
        payment_collection_mode: order.payment_collection_mode || order.paymentCollectionMode || null,
        payment_reference_last4: order.payment_reference_last4 || order.paymentReferenceLast4 || null,
        amount_received: amountReceived,
        change_amount: changeAmount,
        subtotal,
        discount,
        vat: order.vat || order.tax || 0,
        total,
        items,
    };
};

export const printReceipt = async (order = {}) => {
    const receipt = buildReceiptPayload(order);
    const response = await axiosInstance.post("/admin/printer/receipt", { receipt });
    return response.data;
};
